export default __webpack_public_path__ + "static/media/WillsAndBequests.92910795.png";